export enum FieldTypeEnum {
  STRING = "STRING",
  NUMBER = "NUMBER",
  DATE = "DATE",
  DATETIME = "DATETIME",
  ENUM = "ENUM",
  BOOLEAN = "BOOLEAN",
  UNKNOWN = "UNKNOWN"
}

export enum OperatorEnum {
  EQ = "EQ",
  NEQ = "NEQ",
  IS_NOT_EMPTY = "IS_NOT_EMPTY",
  IS_EMPTY = "IS_EMPTY",
  IN = "IN",
  NOT_IN = "NOT_IN",
  LT = "LT",
  LTE = "LTE",
  GT = "GT",
  GTE = "GTE",
  BETWEEN = "BETWEEN"
}

export const OperatorDisplayName: Record<OperatorEnum, string> = {
  [OperatorEnum.EQ]: "equals",
  [OperatorEnum.NEQ]: "does not equal",
  [OperatorEnum.IS_NOT_EMPTY]: "is not empty",
  [OperatorEnum.IS_EMPTY]: "is empty",
  [OperatorEnum.IN]: "includes value(s)",
  [OperatorEnum.NOT_IN]: "does not include value(s)",
  [OperatorEnum.LT]: "less than",
  [OperatorEnum.LTE]: "less than or equal to",
  [OperatorEnum.GT]: "greater than",
  [OperatorEnum.GTE]: "greater than or equal to",
  [OperatorEnum.BETWEEN]: "between"
};
